export default "__VITE_ASSET__Cii56e3s__"